import React, { useEffect, useState, useRef } from "react";
import { Pannellum } from "pannellum-react";
import { getVillagePanorama } from "./getVillagePanorama";

function VillagePanorama({ location }) {
  const PanImage = useRef();
  const [villagePanorama, setVillagePanorama] = useState(null);
  const [villageSlug, setVillageSlug] = useState(null);

  useEffect(() => {
    if (location) {
      const villageSlug = location.pathname.split("/")[2];
      setVillageSlug(villageSlug);
    }
  }, []);

  useEffect(() => {
    if (villageSlug) {
      (async () => {
        const villagePanorama = await getVillagePanorama(villageSlug);
        setVillagePanorama(villagePanorama);
      })();
    }
  }, [villageSlug]);

  const hotspotTooltip = (hotSpotDiv, args) => {
    const markerDiv = document.createElement("div");
    markerDiv.innerHTML = "AHP";
    markerDiv.classList.add("ahp-hotspot-marker");
    hotSpotDiv.appendChild(markerDiv);

    const infoDiv = document.createElement("div");
    infoDiv.innerHTML = "ALDEIAS HISTÓRICAS";
    infoDiv.classList.add("ahp-hotspot-info");
    hotSpotDiv.appendChild(infoDiv);

    // const hDiv2 = document.createElement("div");
    // hDiv2.innerHTML = "AHP";
    // hDiv.classList.add("ahp-hotspot2");
    // hotSpotDiv.appendChild(hDiv2);
    // console.log("E#WRWERTFG");
  };

  return (
    <div>
      {villagePanorama && (
        <Pannellum
          ref={PanImage}
          width="100%"
          height="500px"
          image={villagePanorama?.src}
          pitch={villagePanorama?.pitch || 0}
          yaw={villagePanorama?.yaw || 0}
          // hfov={110}
          autoLoad
          // onRender={() => {
          //   // console.log("pitch:", PanImage.current.getViewer().getPitch());
          //   // console.log("yaw", PanImage.current.getViewer().getYaw());
          // }}
          // hotspotDebug={true}
        >
          {villagePanorama?.hotspots?.map((h) => (
            <Pannellum.Hotspot
              type="info"
              text={h.text}
              pitch={h.pitch}
              yaw={h.yaw}
              // tooltip={(hotSpotDiv, args) => hotspotTooltip(hotSpotDiv, args)}
              // tooltipArg={{ text: "ABC" }}
            />
          ))}
        </Pannellum>
      )}
    </div>
  );
}

export default VillagePanorama;
